export class MovieTitleAnalyzer {
  static analyze(data, excludeMovieId) {
    data = data || {};
    const pageMovies = data.data ?? [];
    const movies =
      excludeMovieId > 0
        ? pageMovies.filter((movie) => movie.id !== excludeMovieId)
        : pageMovies;

    let total = data.total ?? 0;
    if (
      excludeMovieId > 0 &&
      pageMovies.some((movie) => movie.id === excludeMovieId)
    ) {
      total = Math.max(0, total - 1);
    }

    const titles = movies.map((movie) => movie.primaryTitle);
    const additionalCount = Math.max(0, total - titles.length);

    return { additionalCount, titles };
  }
}
